import {
  StringArrayParam,
  BooleanParam,
  NumberParam,
  QueryParamConfigMap,
  StringParam,
  withDefault,
  DateRangeParam,
  NullableStringArrayParam,
} from 'common/hooks/customSearchParams';
import { DEFAULT_PAGE_SIZE } from './config';

export const DEFAULT_DATE_RANGE_PARAM = {
  startDate: null,
  endDate: null,
  includeStartDate: null,
  includeEndDate: null,
  exactDate: null,
};

export const WATCH_LIST_QUERY_PARAMS: QueryParamConfigMap = {
  sortBy: withDefault(StringParam, 'default'),
  page: withDefault(NumberParam, 1),
  pageSize: withDefault(NumberParam, DEFAULT_PAGE_SIZE),
  containerNumbers: withDefault(StringArrayParam, []),
  importStatus: withDefault(StringArrayParam, []),
  containerStatus: withDefault(StringArrayParam, []),
  shippingLine: withDefault(StringArrayParam, []),
  containerType: withDefault(StringArrayParam, []),
  terminalPickupKeys: withDefault(StringArrayParam, []),
  portPickupCodes: withDefault(StringArrayParam, []),
  availableForPickup: BooleanParam,
  demurrageDue: BooleanParam,
  closedArea: BooleanParam,
  pickupAppointmentStatus: withDefault(StringArrayParam, []),
  returnAppointmentStatus: withDefault(StringArrayParam, []),
  customers: withDefault(NullableStringArrayParam, []),
  holdTypes: withDefault(StringArrayParam, []),
  lastFreeDayAt: withDefault(DateRangeParam, DEFAULT_DATE_RANGE_PARAM),
  gatedOutAt: withDefault(DateRangeParam, DEFAULT_DATE_RANGE_PARAM),
  gatedInAt: withDefault(DateRangeParam, DEFAULT_DATE_RANGE_PARAM),
  pickupAppointmentAt: withDefault(DateRangeParam, DEFAULT_DATE_RANGE_PARAM),
  watchedAt: withDefault(DateRangeParam, DEFAULT_DATE_RANGE_PARAM),
  addContainers: BooleanParam,
};
